module.exports = __webpack_public_path__ + "img/Weapon_99.36009308.png";